export const modalConstants = {
  OPEN: 'MODAL_OPEN',
  CLEAR: 'MODAL_CLEAR',
};
